import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const PageLoader = () => (
  <div className="flex min-h-[50vh] items-center justify-center" data-testid="page-loader"><Loader2 className="h-7 w-7 animate-spin text-[#3B1272]" /></div>
);

export const RequireCustomer = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to="/accedi" state={{ from: loc.pathname + loc.search }} replace />;
  if (["admin", "moderator", "operator"].includes(user.role)) return <Navigate to={`/${process.env.REACT_APP_ADMIN_PATH}`} replace />;
  return children;
};
